import script from "./index.ce.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.ce.vue?vue&type=script&setup=true&lang=ts"

import _style_0 from "./index.ce.vue?vue&type=style&index=0&id=06c70246&inline&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]],['__scopeId',"data-v-06c70246"]])

export default __exports__